<script setup lang="ts">
import { defineQuery } from "groq"
import { NuggetCard } from "#components"
import { buildBookSchema } from "~/utils/schema"

const route = useRoute()

const BOOK_QUERY =
  defineQuery(`*[_type == "book" && slug.current == $slug]{..., author->{name, slug}, "nuggets": *[_type=='nugget' && references(^._id)]{
    _id,
    displayedId,
    type,
    text,
    slug,
    author->{name, slug},
    book->{title, slug},
    music->{title, slug},
  }}[0]`)
const { data: book, status } = useSanityQuery(BOOK_QUERY, {
  slug: route.params.slug,
})

const siteConfig = useSiteConfig()

useSchemaOrg(() => buildBookSchema(book.value, siteConfig.url))
</script>

<template>
  <div class="container mx-auto mt-32">
    <div v-if="status === 'pending'">Loading...</div>
    <div v-else-if="status === 'error'">Error</div>
    <div v-else-if="status === 'success' && book">
      <h1 class="text-4xl font-bold">{{ book.title }}</h1>
      <p v-if="book.author" class="text-xl text-gray-500 mt-2">
        by {{ book.author.name }}
      </p>
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
        <NuggetCard
          v-for="nugget in book.nuggets"
          :key="nugget._id"
          :nugget="nugget"
          :status="status"
        />
      </div>
    </div>
  </div>
</template>
